import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";

import {TwitterTweetEmbed} from 'react-twitter-embed';

import {Brand} from "../Brand";

// CUSTOMIZATION: insert here the list of Tweet IDs, and they'll be rendered in order
const tweetEmbedIDs = [/*'1262940974352699392',*/ '1263093057903198208'];

const useLocalStyles = makeStyles((theme) => ({
  dailyTitle: {
    color: Brand.styles.appbar_blue.backgroundColor,
    marginBottom: '12px',
  },
  twitterItem: {
    minHeight: '200px', // placeholder for the min vertical space of a tweet - in our typical case.
    marginBottom: '10px',
    padding: 0,
  },
  dailyEndTitle: {
    color: Brand.styles.appbar_blue.backgroundColor,
    // textTransform: 'uppercase',
    marginBottom: '12px',
  },
}));

export function DailyFeed() {
  const classes = useLocalStyles();
  const hasTweets = tweetEmbedIDs.length > 0;
  return (
    <List>
      {/* Header: Feedback */}
      <ListItem><ListItemText>
        <Typography variant="h6" align="left" className={classes.dailyTitle}>
          Feedback!
        </Typography>
        <Typography>How neat is this experiment?</Typography>
      </ListItemText></ListItem>
      {/* Tweets here */}
      {hasTweets && tweetEmbedIDs.map(tweetId =>
        <ListItem key={tweetId} className={classes.twitterItem}>
          <ListItemText>
            <TwitterTweetEmbed tweetId={tweetId} options={{
              // options: https://developer.twitter.com/en/docs/twitter-for-websites/embedded-tweets/guides/embedded-tweet-parameter-reference
              width: 520,           // max, experimental
              align: 'center',      // center
              dnt: true,            // do-not-track to protect our users
            }}/>
          </ListItemText>
        </ListItem>
      )}
      {/* Conclusion */}
      <ListItem><ListItemText>
        <Typography variant="h6" align="left" className={classes.dailyEndTitle}>
          Thanks for checking this out
        </Typography>
        <Typography>- You're AWESOMO, too</Typography>
      </ListItemText></ListItem>
    </List>
  )
}
